import { HangupIcon } from '../icons.js';
import { ModalOverlay } from '../components/ModalOverlay.js';

interface Props {
  onCancel: () => void;
  /** Session length the learner requested, shown so both sides see the ask. */
  durationMinutes: number;
  /** Topic the learner picked, if any — echoed so they can see it went out. */
  topic?: string | null;
}

// Shown to a learner while their session invite is out to a guide, until the
// guide accepts (→ CallView), declines/leaves (→ error notice in the lobby), or
// the learner cancels here. Bound to LobbyContext's `pendingPeer`, so the
// accept/decline/timeout paths dismiss it without any extra wiring.
export function ConnectingModal({ onCancel, durationMinutes, topic }: Props) {
  return (
    <ModalOverlay
      role="dialog"
      aria-modal="true"
      aria-labelledby="connecting-title"
      className="z-50 bg-ink-900/60"
    >
      <div className="max-w-sm w-[90%] mx-auto rounded-2xl bg-canvas-light dark:bg-canvas-dark p-8 sm:p-10 text-center shadow-xl ring-1 ring-ink-900/10 dark:ring-white/10">
        <h2
          id="connecting-title"
          className="h-card text-ink-900 dark:text-ink-100 mb-6"
        >
          Connecting with the guide…
        </h2>

        {/* "Starting [ASL Go logo] Session" */}
        <div className="flex items-center justify-center gap-2 text-lg font-medium text-ink-700 dark:text-ink-200 mb-3">
          <span>Starting</span>
          <img
            src="/asl-go-logo.avif"
            alt="ASL Go"
            className="h-6 w-auto select-none"
          />
          <span>Session</span>
        </div>

        <p className="text-sm text-ink-500 dark:text-ink-400 mb-7">
          {durationMinutes}-minute session
          {topic ? (
            <>
              <br />
              Topic: {topic}
            </>
          ) : null}
        </p>

        <div
          role="status"
          aria-label="Connecting"
          className="mx-auto mb-8 h-7 w-7 rounded-full border-2 border-ink-900/20 border-t-ink-900/70 dark:border-ink-100/20 dark:border-t-ink-100/70 animate-spin"
        />

        <button
          type="button"
          autoFocus
          onClick={onCancel}
          className="btn-ghost justify-center w-full
                     hover:!text-status-error hover:!border-status-error
                     dark:hover:!text-status-errorBright dark:hover:!border-status-errorBright"
        >
          <HangupIcon /> Cancel
        </button>
      </div>
    </ModalOverlay>
  );
}
